import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import InterviewDetails from "../../../../components/Client/ClientInterviewSchedular/InterviewDetails/InterviewDetails";
import SelectedCandidatesTab from "../../../../components/Client/ClientInterviewSchedular/SelectedCandidatesTab/SelectedCandidatesTab";
import SelectedDateTime from "../../../../components/Client/ClientInterviewSchedular/SelectedDateTime/SelectedDateTime";
import SelectedCandidates from "../../../../components/Client/ClientInterviewSchedular/SelectedCandidates/SelectedCandidates";
import axios from "../../../../services/axios-service";
import "./InterviewViewRecruiter.css";
import ConsoleLog from "../../../../hoc/ConsoleLog/ConsoleLog";
import moment from "moment";
import Icon from "../../../../components/UI/Icon/Icon";
import getS3ImageUrl from "../../../../lib/s3FileHandler";
import MediaQuery from "react-responsive";

class InterviewViewRecruiter extends Component {
  state = {
    recruiterInterviewData: "",
    candidateImageCount: 0
  };

  componentDidMount() {
    let interviewId = this.props.location.state.interviewId;
    this.fetchScheduledCandidateData(interviewId);
  }
  /**
   * @desc fetches the scheduled client details view
   * @param interviewId
   * @return null
   */
  fetchScheduledCandidateData = interviewId => {
    axios
      .get("/galaxy/interview/" + interviewId)
      .then(response => {
        ConsoleLog("response notification", response.data);
        const recruiterInterviewData = response.data;
        recruiterInterviewData.candidates.map(candidate => {
          getS3ImageUrl(candidate.candidate_image, this.props.user)
            .then(url => {
              candidate.s3SignedUrl = url;
              this.setState({
                candidateImageCount: this.state.candidateImageCount + 1
              });
            })
            .catch(() => {
              this.setState({
                candidateImageCount: this.state.candidateImageCount + 1
              });
            });
        });
        this.setState({ recruiterInterviewData });
        // ConsoleLog("scheduler",this.state.interviewScheduledData.interviews,this.state.interviewScheduledData.interviews.length,this.state.interviewScheduledData.progressed)
      })
      .catch(error => {
        ConsoleLog(error);
        throw error;
      });
  };

  render() {
    ConsoleLog(
      "slots",
      this.state.recruiterInterviewData.client_interview_attachments
    );
    const recruiterInterviewData = this.state.recruiterInterviewData;
    let candidateSlots = [];
    if (
      recruiterInterviewData.slots &&
      recruiterInterviewData.slots.length > 0
    ) {
      let toDate = "";
      let fromDate = "";
      let durationArray = [];
      candidateSlots = recruiterInterviewData.slots.map((element, index) => {
        if (recruiterInterviewData.client_interview_duration === "30 mins") {
          fromDate = moment.utc(element.slot).format("hh:mma");
          toDate = moment
            .utc(element.slot)
            .add(30, "minutes")
            .format("hh:mma");
        } else {
          durationArray = recruiterInterviewData.client_interview_duration.split(
            " "
          );
          fromDate = moment.utc(element.slot).format("hh:mma");
          toDate = moment
            .utc(element.slot)
            .add(durationArray[0], "hours")
            .format("hh:mma");
        }
        return {
          date: moment.utc(element.slot).format("ddd D MMMM YYYY"),
          time: fromDate + " - " + toDate,
          slotStatus: element.status
        };
      });
    }
    return (
      <div className="rec-interview-view-container">
        <div className="selected-job-title-main">
          <div
            className="rec-interview-view-back"
            onClick={() => {
              this.props.history.push("/recruiter/interview-scheduler");
            }}
          >
            <Icon icon="left-arrow" className="rec-interview-view-back-icon " />
            <h1 className="selected-job-title">
              <p>
                Interview details for{" "}
                <span>
                  {recruiterInterviewData.job_name}-
                  {recruiterInterviewData.job_bh_id}
                </span>
              </p>
            </h1>
          </div>
        </div>
        {recruiterInterviewData.candidates ? (
          <div className="rec-interview-view-details-section">
            <MediaQuery query="(min-device-width: 768px)">
              <div className="rec-wrap ">
                <div className="rec-head">
                  <h4 className="rec-note">Note from your client </h4>
                  <span className="prefix-client-info">
                    (This note is only visible to you)
                  </span>
                  <span className="prefix-author">
                    Interview created by: {recruiterInterviewData.requested_by}
                  </span>
                </div>
                <div className="prefix-client-message desktop-padding">
                  {recruiterInterviewData.client_interview_client_message
                    ? '"' +
                      recruiterInterviewData.client_interview_client_message +
                      '"'
                    : "Not specified"}
                </div>
              </div>
            </MediaQuery>
            <MediaQuery query="(max-device-width: 767px)">
              <div className="rec-wrap">
                <div className="rec-head">
                  <span className="prefix-author">
                    Interview created by: {recruiterInterviewData.requested_by}
                  </span>
                  <h4 className="rec-note">Note from your client </h4>
                  <span className="prefix-client-info">
                    (This note is only visible to you)
                  </span>
                </div>
                <div className="prefix-client-message">
                  {recruiterInterviewData.client_interview_client_message
                    ? '"' +
                      recruiterInterviewData.client_interview_client_message +
                      '"'
                    : "Not specified"}
                </div>
              </div>
            </MediaQuery>
            <div className="display-info">
              <h4>
                The client has selected the following candidates, dates and
                times for interview.
              </h4>
              <p>Please review and edit any details where necessary.</p>
            </div>
            <div className="interview-details-section">
              <InterviewDetails
                interviewLocation={
                  recruiterInterviewData.client_interview_location
                }
                interviewType={recruiterInterviewData.client_interview_type}
              />
              {this.state.candidateImageCount ==
              recruiterInterviewData.candidates.length ? (
                recruiterInterviewData.client_interview_status === "Pending" ? (
                  <div className="rec-interview-view-tabs">
                    <SelectedCandidates
                      candidates={
                        this.state.candidateImageCount ==
                        recruiterInterviewData.candidates.length
                          ? recruiterInterviewData.candidates
                          : ""
                      }
                    />
                  </div>
                ) : (
                  <SelectedCandidatesTab
                    candidates={recruiterInterviewData.candidates}
                    duration={recruiterInterviewData.client_interview_duration}
                  />
                )
              ) : null}
              <SelectedDateTime candidateSlots={candidateSlots} />
              <div className="rec-message">
                <h4 className="rec-message-title">Note to your candidates</h4>
                <p className="rec-message-text">
                  {recruiterInterviewData.client_interview_recruiter_message
                    ? recruiterInterviewData.client_interview_recruiter_message
                    : "Not specified"}
                </p>
              </div>
              {recruiterInterviewData.client_interview_attachments ? (
                <div className="attachments">
                  {recruiterInterviewData.client_interview_attachments
                    .split(";")
                    .map(file => {
                      return (
                        <div className="rec-attachments">
                          <Icon
                            icon="Attached-doc"
                            className="file-preview-icon"
                          />
                          <span
                            className="rec-attachment-title"
                            title={file.split("/")[2]}
                          >
                            {file.split("/")[2]}
                          </span>
                        </div>
                      );
                    })}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}
/**
 * @desc connecting to redux store
 * @param state
 * @return redux state
 */
const mapStateToProps = state => {
  return {
    // pool: state.talentPool.pool,
    // activeCandidateId: state.talentPool.activeCandidateId,
    // jobTitleId :state.talentPool.jobTitleId,
    // profileInfo: state.candidateProfile.profileInfo,
    // jobs: state.talentPool.jobList,
    user: state.cognito.user,
    // clientDetails: state.clientProfile.clientDetails,
    // companyType:state.talentPool.companyType,
    jobTitle: state.talentPool.jobTitle,
    jobTitleBHID: state.talentPool.jobTitleBHID
  };
};

export default connect(mapStateToProps)(InterviewViewRecruiter);



// WEBPACK FOOTER //
// ./src/container/Recruiter/RecruiterInterviewDetails/InterviewViewRecruiter/InterviewViewRecruiter.js